import axios from 'axios'
import ElementUI from 'element-ui';
import router from '@/router'
import { ensureMemberAccess } from '@/services/memberAccess'

const CancelToken = axios.CancelToken;
let cancel;
//->对get请求传递过来的参数处理
let Axios = axios.create({
    timeout: 60000,
    headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'is-ajax-request': 'true',
        'client-name': process.env.VUE_APP_CLIENT_NAME,
    },
    cancelToken: new CancelToken(function executor(c) {
        cancel = c;
    })
});
Axios.defaults.baseCasURL = "/cas";
Axios.defaults.baseCatURL = "/cat";

function paramsToUrl(url, params) {
    if (!params) return url;
    for (var key in params) {
        if (params[key] && params[key] !== 'undefined') {
            if (url.indexOf('?') != -1) {
                url += '&' + '' + key + '=' + params[key] || '' + ''
            } else {
                url += '?' + '' + key + '=' + params[key] || '' + ''
            }
        }
    }
    return url
}

function statusFn(url, params) {
    return new Promise((resolve, reject) => {
        Axios.post(url, params).then(res => {
            var errorCode = res.data.errorCode;
            if (errorCode === "CAT-V004") {
                router.push({
                    name: "jurisdiction"
                });
                resolve(undefined);
                return;
            }
            if (res.data.resultCode === "0") {
                ElementUI.Message.closeAll();
                ElementUI.Message({
                    message: `${res.data.errorDesc}(${errorCode})`,
                    type: "error"
                });
                resolve(undefined);
                return;
            } else {
                resolve(res)
            }

        }).catch(err => {
            reject(err)
        })
    })
}

// 处理后台返回错误
function errorFn(res) {
    let errorCode = res.data.errorCode;
    if (errorCode === "CAT-V004") {
        router.push({
            name: "jurisdiction"
        });
        return false;
    }
    if (errorCode === "CAT-V004" || errorCode === "CAT-V003" || errorCode === "CAT-U011") {
        router.push({
            name: "login"
        });
        return false;
    }
    if (res.data.resultCode === "0") {
        ElementUI.Message.closeAll();
        ElementUI.Message({
            message: `${res.data.errorDesc}(${errorCode})`,
            type: "error"
        });
        return false;
    } else {
        return true
    }
}

function messageFn(err) {
    let message = "网络出错";
    if (err && err.response) {
        switch (err.response.status) {
            case 400:
                message = '请求错误';
                break;
            case 401:
                message = '未授权，请登录';
                break;
            case 403:
                message = '拒绝访问';
                break;
            case 404:
                message = `请求地址出错`;// ${err.response.config.url}
                break;
            case 408:
                message = '请求超时';
                break;
            case 500:
                message = '服务器内部错误';
                break;
            case 501:
                message = '服务未实现';
                break;
            case 502:
                message = '网关错误';
                break;
            case 503:
                message = '服务不可用';
                break;
            case 504:
                message = '网关超时';
                break;
            case 505:
                message = 'HTTP版本不受支持';
                break;
            case 598:
                message = 1;
                break;
            default:
                message = '网络出错';
                break
        }
        if (err.response.status == 401 && CAS_ENABLE) {
            console.log(err.response.headers.location);
            localStorage.setItem("myUser", '');
            window.location.href = err.response.headers.location;
            return
        }
    }

    if (message === 1) {
        ElementUI.Message.closeAll();
        ElementUI.Message({
            message: "操作过于频繁，请稍后重试",
            type: "error"
        });
    } else {
        ElementUI.Message.closeAll();
        ElementUI.Message({
            message: message || '网络出错' + "，请重试！",
            type: "error"
        });
    }
}

//ajax封装请求的方法
async function requireData(url, params = {}, type, status, item) {
    if (!url) return false;
    if (!(await ensureMemberAccess(url, item))) return false;
    switch (item) {
        case "cat1":
            url = Axios.defaults.baseCatURL + url;
            break;
        case "cat2":
            url = Axios.defaults.baseCasURL + url;
            break;
        default:
        // url = Axios.defaults.baseM4URL + url
    }
    let href = window.location.href;
    if (href.length > 1000) {
        href = window.location.origin + "/#/home/projectHome/fileList"
    }
    Axios.defaults.headers['redirect-url'] = href;
    if (localStorage.myPlatformType !== undefined && localStorage.myPlatformType.length > 0) {   // 平台编码
        params.platformType = Number(localStorage.myPlatformType)
    } else {
        params.platformType = Number(VUE_APP_PLATFORMTYPE)
    }
    params.companyCode = localStorage.myCompanyCode; // 公司编码
    if (type === 'get') {
        url = paramsToUrl(url, params);
        return new Promise((resolve, reject) => {
            Axios.get(url, params).then(res => {
                if (status === 2) {
                    resolve(res.data);
                    return (res.data)
                } else {
                    if (!errorFn(res)) {
                        resolve(res.data);
                        return (res.data)
                    } else {
                        resolve(res.data);
                        return (res.data)
                    }
                }

            }).catch((err, res) => {
                messageFn(err, res);
                reject(err)
            })
        })
    } else if (type === 'post' && status === 1) {
        return new Promise((resolve, reject) => {
            Axios.post(url, params).then(res => {
                if (!errorFn(res)) {
                    resolve(res.data)
                } else {
                    resolve(res.data)
                }
            }).catch(err => {
                reject(err)
            })
        })
    } else if (type === 'post' && status === 2) {
        return new Promise((resolve, reject) => {
            Axios.post(url, params).then(res => {
                resolve(res.data)
            }).catch(err => {
                reject(err)
            })
        })
    } else {
        return new Promise((resolve, reject) => {
            Axios.post(url, params).then(res => {
                if (!errorFn(res)) {
                    resolve(res.data)
                } else {
                    resolve(res.data)
                }
            }).catch((err, res) => {
                messageFn(err, res);
                reject(err)
            })
        })
    }
}


//ajax封装请求的方法
async function requireData2(url, params = {}, type, status, item) {
    if (!url) return false;
    if (!(await ensureMemberAccess(url, item))) return false;
    switch (item) {
        case "cat1":
            url = Axios.defaults.baseCatURL + url;
            break;
        case "cat2":
            url = Axios.defaults.baseCasURL + url;
            break;
        default:
    }
    let href = window.location.href;
    if (href.length > 1000) {
        href = window.location.origin + "/#/home/projectHome/fileList"
    }
    Axios.defaults.headers['redirect-url'] = href;
    return new Promise((resolve, reject) => {
        Axios.get(url, params).then(res => {
            if (!errorFn(res)) {
                resolve(res.data)
            } else {
                resolve(res.data)
            }
        }).catch((err, res) => {
            messageFn(err, res);
            reject(err)
        })
    })
}

export default {
    install(Vue, options) {
        //->接口1的请求数据方法
        Vue.prototype.catReq1Service = function (url, params, type, status) {
            return requireData.call(this, url, params, type, status, 'cat1')
        };
        //->接口2的请求数据方法 编辑器页面 单词补全接口
        Vue.prototype.casReqService = function (url, params, type, status) {
            return requireData.call(this, url, params, type, status, 'cat2')
        };

        //->获取多引擎翻译信息
        Vue.prototype.getEngineInfo = function (url, params, type, status) {
            return requireData.call(this, url, params, type, status, 'cat1')
        };

        //->单接口调用机翻接口
        Vue.prototype.getEngineResult = function (url, params, type, status) {
            return requireData.call(this, url, params, type, status, 'cat1')
        };
        //->单接口调用机翻接口
        Vue.prototype.cancelPending = () => {
            cancel('用户取消操作.');
        };

        //->离线上传将文件和任务绑定
        Vue.prototype.taskUpload = function (url, params, type, status) {
            return requireData2.call(this, url, params, type, status, 'cat1')
        };

        //->离线文件下载
        Vue.prototype.taskDownload = function (url, params, type, status) {
            return requireData2.call(this, url, params, type, status, 'cat1')
        };


        //获取系统支持的语种POST
        Vue.prototype.getSystemLanguage = function (url, params, type, status) {
            return requireData.call(this, url, params, type, status, 'cat1')
        };


        //新建断句规则Get
        Vue.prototype.establishPunctuate = function (url, params, type, status) {
            return requireData.call(this, url, params, type, status, 'cat1')
        };

        //获取断句规则列表
        Vue.prototype.punctuateList = function (url, params, type, status) {
            return requireData.call(this, url, params, type, status, 'cat1')
        };

        //删除断句规则列表
        Vue.prototype.punctuateDelete = function (url, params, type, status) {
            return requireData.call(this, url, params, type, status, 'cat1')
        };

        //断句规则修改
        Vue.prototype.punctuateEdit = function (url, params, type, status) {
            return requireData.call(this, url, params, type, status, 'cat1')
        };

        //断句规则查找已存在语种
        Vue.prototype.punctuateLanguageExist = function (url, params, type, status) {
            return requireData.call(this, url, params, type, status, 'cat1')
        };

        //断句规则模板下载
        Vue.prototype.punctuateDowload = function (url, params, type, status) {
            return requireData2.call(this, url, params, type, status, 'cat1')
        };

        //断句规则配置
        Vue.prototype.punctuateConfiguration = function (url, params, type, status) {
            return requireData.call(this, url, params, type, status, 'cat1')
        };

        //获取当前句的QA信息
        Vue.prototype.currentQACheck = function (url, params, type, status) {
            return requireData.call(this, url, params, type, status, 'cat1')
        };

        //    获取片段的HTML
        Vue.prototype.partHTML = function (url, params, type, status) {
            return requireData.call(this, url, params, type, status, 'cat1')
        };

    }

}


